import { render, staticRenderFns } from "./performances_index.vue?vue&type=template&id=176c1a5b&scoped=true"
import script from "./performances_index.vue?vue&type=script&lang=js"
export * from "./performances_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c1a5b",
  null
  
)

export default component.exports